export const gtmPush = (category, action, label, data) => {
  let e = {
    event: category,
    eventAction: action,
    eventLabel: label,
  };
  if (data) {
    e.data = data;
  }
  if (window.dataLayer) {
    window.dataLayer.push(e);
  }
  if (process.env.RAZZLE_APP_ENV === "local") { console.log("[gtm]", e); }
};

export const gtmPageview = (path) => {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'VirtualPageview',
            virtualPageURL: path,
        });
    }
    if (process.env.RAZZLE_APP_ENV === "local") {
      console.log("[gtm]", {
          event: 'VirtualPageview',
          virtualPageURL: path,
      });
    }
}
